import { RIPSIM_ICONS as ICONS } from "src/app/shared/models/icon-config.model";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ButtonModule } from "primeng/button";
import { Subject, takeUntil } from "rxjs";
import { GeneralDialogComponent } from "../general-dialog/general-dialog.component";
import { RsIconComponent } from "../../icons/icon.component";

export const EXPIRED_SESSION_DIALOG_QUERY_PARAM = "expired";
@Component({
  selector: "rs-app-expired-session-dialog",
  imports: [ButtonModule, GeneralDialogComponent, RsIconComponent],
  standalone: true,
  templateUrl: "./expired-session-dialog.component.html"
})
export class ExpiredSessionDialogComponent implements OnInit, OnDestroy {
  visible = false;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  readonly ICONS = ICONS;

  ngOnInit(): void {
    this.route.queryParamMap.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.visible = params.get(EXPIRED_SESSION_DIALOG_QUERY_PARAM) === "true";
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close(): void {
    this.clearExpiredParam();
  }

  clearExpiredParam(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { expired: null },
      queryParamsHandling: "merge"
    });
  }
}
